import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection } from '@iotv/iotv-v3-types';

const typeName = 'TurbidityReadings';

export type TurbidityReadingsProps = {
  turbidityLevel?: number;
  turbidityChanges?: number;
  waterTemperature?: number;
};

export class TurbidityReadings extends ModelCommon {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }

  turbidityLevel?: number;
  turbidityChanges?: number;
  waterTemperature?: number;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      turbidityLevel: { type: 'Number', editable: true, label: 'Turbidity Level', name: 'turbidityLevel', description: 'Turbidity Level - tbc' },
      turbidityChanges: {
        type: 'Number',
        editable: true,
        label: 'Turbidity Changes',
        name: 'turbidityChanges',
        description: 'Amount of change in turbidity (NTU) between two periods',
      },
      waterTemperature: {
        type: 'Number',
        editable: true,
        label: 'Water Temperature',
        name: 'waterTemperature',
        description: 'Water Temperature - degrees Celsius',
      },
    };
  };
}
